import vuex from './Vuex/index'

export default {
  vuex
}
